module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjNWY2MzY4Ij48cGF0aCBkPSJNNDQwLTEyMHYtMjQwaDgwdjgwaDMyMHY4MEg1MjB2ODBoLTgwWm0tMzIwLTgwdi04MGgyNDB2ODBIMTIwWm0xNjAtMTYwdi04MEgxMjB2LTgwaDE2MHYtODBoODB2MjQwaC04MFptMTYwLTgwdi04MGg0MDB2ODBINDQwWm0xNjAtMTYwdi0yNDBoODB2ODBoMTYwdjgwSDY4MHY4MGgtODBabS00ODAtODB2LTgwaDQwMHY4MEgxMjBaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product-icons/tune.svg
// module id = BnrX
// module chunks = 79